<template>
  <div class="wrapper" @click="goFullscreen">
    <h1>{{printTitle}}</h1>
    <div class="list">
      <ul class="yet" >
        <li
          class="fade_in"
          v-for="(name, index) in printList"
          :key="name"
          :style="{ animationDelay: `${index * 0.2}s` }"
        >
          {{ name }}
        </li>
      </ul>
      <div class="yets" v-if="printYet.length > 0">
        <h2>未提出者</h2>
        <ul class="yet">
          <li
            class="fade_in"
            v-for="(name, index) in printYet"
            :key="name"
            :style="{ animationDelay: `${index * 0.2}s` }"
          >
            {{ name }}
          </li>
        </ul>
      </div>
    </div>
  </div>
  <!-- <div class="slideshow">
    <h1>{{ slides[currentIndex] }}</h1>
  </div> -->
</template>

<script>
import { toRaw } from "vue";

export default {
  props: [
    "interval",
    "submissions", "students", "submissionStatus"
  ],
  data() {
    return {
      currentIndex: 0,
      date: '',
      submissionCount: 0, // 提出物数
      localSubmissions: this.submissions, // 教科
      localStudents: this.students, // 生徒
      localStatus: this.submissionStatus, // 提出状況
      statusArr: [], // 取得した配列を保持
      printTitle: '', // 表示用タイトル
      printList: [], // 表示するリスト
      printYet: [] // 未提出者リスト
    }
  },
  created() {
    this.date = new Date().toLocaleDateString("ja-JP", {year: "numeric",month: "2-digit",day: "2-digit"}).replaceAll('/', '-'); // 日付の取得
  },
  mounted() {
    console.log(this.date);
    // this.showSlide();
    // setInterval(this.showSlide, this.interval || 3000);
    setInterval(this.showStatus, this.interval || 3000);
    // 仮
    this.showStatus(); // 表示
    // this.setAnimationDelay(); // アニメーション
  },
  methods: {
    // showSlide() {
    //   this.currentIndex = (this.currentIndex + 1) % this.slides.length;
    // },
    goFullscreen() {
      document.documentElement.requestFullscreen();
    },
    showStatus() { // 提出状況をスライド表示
      // currentIndex=0 すぐに更新
      if( this.submissionCount == 0 ) {
        this.updateStatus();
      }

      // 表示
      console.log(this.submissionCount);
      if( this.submissionCount < 1 ) { // 提出無し
        return;
      }
      const status = toRaw(this.statusArr);
      console.log(status[this.currentIndex]);

      // タイトル更新
      this.printTitle = this.localSubmissions[status[this.currentIndex][0]];

      // 名前リスト更新
      let doneList = [];
      status[this.currentIndex][1].forEach(id => {
        doneList.push( this.localStudents[id] );
      });
      this.printList = doneList;

      // 未提出者リスト
      let fullList = []; // 全員名簿
      const names = toRaw(this.localStudents);
      Object.values(names).forEach(name => {
        fullList.push(name);
      });
      this.printYet = fullList.filter(item => !doneList.includes(item));

      // console.log(this.printYet);

      // currentIndex++
      this.currentIndex++;
      if( this.submissionCount == this.currentIndex) { // 最後
        this.updateStatus();
        this.currentIndex = 0; // 初期化
      }

    },
    updateStatus() { // 提出状況を更新
      console.log('更新');
      // 今日の提出データなし
      if( !this.localStatus[this.date] ) {
        this.printList.push('提出物を登録してください。');
        this.printTitle = '提出未登録';
        return;
      }

      // 提出物の種類をカウント
      const status = toRaw(this.localStatus[this.date]);
      // console.log(status);
      // console.log(Object.keys(status).length);
      this.submissionCount = Object.keys(status).length;
      
      // 値だけを配列に変換
      this.statusArr = Object.entries(status);
      // values.forEach((key, val) => {
      //   console.log(key, val);
      // });
    }
    // setAnimationDelay() {
    //   const lis = document.querySelectorAll('.fade_in');
    //   lis.forEach((li, i) => {
    //     li.style.animationDelay = `${0.2 * (i + 1)}s`;
    //   });
    // }
  }
};
</script>

<style scoped>
.wrapper {
  margin: 100px auto 0 auto;
}

h1 {
    position: absolute;
    top: 0;
    left: 0;
    margin-left: 1em;
    font-size: 3vw;
    z-index: 1;
}

.list {
  margin: 0 20px;
  padding: 20px;
  box-sizing: border-box;
  background-color: white;
  z-index: 2;
}
.list ul.yet {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  gap: 20px;
  margin: 0;
  padding: 20px;
}
.list ul.yet li.fade_in {
  opacity: 0;
  transform: translateY(10px);
  animation: fadeInUp 0.5s forwards;
  margin: 0.3em 0.7em; /* お好みで間隔 */
  font-size: 3vw;
}
@keyframes fadeInUp {
  /* from {
    opacity: 0;
    transform: translateY(10px);
  } */
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.yets {
  display: flex;
  flex-wrap: wrap;  
  margin-top: 20px;
  padding: 10px;
  border: #ffc107 5px solid;
  background-color: #fad871;
  border-radius: 10px;
}
.yets h2 {
  margin: 0;
  font-size: 2vw;
  line-height: 1.0;
  color: #dc3545;
}
.yets ul.yet {
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  gap: 10px;
  margin: 0;
  padding: 20px;
}
.yets ul.yet li.fade_in {
  opacity: 0;
  transform: translateY(10px);
  animation: fadeInUp 0.5s forwards;
  margin: 0.3em 0.7em; /* お好みで間隔 */
  font-size: 2vw;
  line-height: 1.0;
}


.slideshow {
  width: 100vw;
  height: 100vh;
  background: black;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 5vw;
}
</style>
